export const coreSizeLogsModalStyle = {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: "90%",
    maxWidth: 1100,
    maxHeight: "85vh",
    bgcolor: "background.paper",
    borderRadius: 2,
    boxShadow: 24,
    display: "flex",
    flexDirection: "column",
    overflow: "hidden",
  };
  
  export const coreSizeLogsModalHeaderCellSx = {
    fontWeight: 700,
    fontSize: 12,
    color: "text.secondary",
    bgcolor: "grey.100",
    py: 1.25,
    whiteSpace: "nowrap",
  };